import React, { Component } from 'react';
import { map } from 'lodash';

export default class Photos extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    let photos = this.props.companyImages && map(this.props.companyImages, (image, index) => {
      if (index <= 2) {
        return (<li key={index} className="upload-images" onClick={() => this.props.openModal(index)}>
          <img src={image.thumbnail} alt="" />
        </li>);
      } else if (index == 3) {
        if (this.props.companyImages.length > 4) {
          return (<li key={index} className="upload-images" onClick={() => this.props.openModal(index)}>
            <img src={image.thumbnail} alt="" />
            <label className="more-popup">
              {'+' + (this.props.companyImages.length - 4) + ' More'}
            </label>
          </li>);
        } else {
          return (<li key={index} className="upload-images" onClick={() => this.props.openModal(index)}>
            <img src={image.thumbnail} alt="" />
          </li>);
        }
      } else {
        return '';
      }
    });
    return (
      <div>
        <div className="vendor-services">
          <div className="vendor-description">
            <h4>Photos</h4>
            {this.props.companyImages && this.props.companyImages.length ? <ul className="figure">
              {photos}
            </ul> : <div> No Photos Found.</div>}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/VendorProfile/Photos.jsx